<template>
  <div class="page-intro">
    <div class="page-intro__logo">
      <img :alt="$t('page.header')" :src="getLogoImage" height="188" width="325" />
    </div>
    <h1 class="page-intro__text">{{ $t("page.header") }}</h1>
  </div>
</template>
<script>
export default {
  name: "ThePageIntro",
  computed: {
    getLogoImage() {
      return require("@static_promo_pages/common/static/images/logo.webp");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/the-page-intro";
</style>
